import Immutable from "immutable";

const conversationsListMap = Immutable.Map({
  pageSize: 20,
  pageNumber: 1,
  logsLoading: false,
  currentConversationIndex: 0,
  hasMoreInConversation: true,
  hasError: false,
  selectedLog: null,
  isTransitioning: false,
  isTraining: false
});

export const conversationsList = (state = conversationsListMap, action) => {
  switch (action.type) {
    case "SET_CONVERSATIONS_LIST":
      return state.merge(action.payload);
    case "GET_LOGS_REQUEST":
      return state.set("logsLoading", true);

    case "GET_LOGS_SUCCESS": {
      const { log } = action.response.data;
      const newState = state.merge({
        logsLoading: false,
        hasMoreInConversation: log.length === state.get("pageSize")
      });

      if (log.length < newState.get("pageSize")) {
        return newState.merge({
          currentConversationIndex: newState.get("currentConversationIndex") + 1,
          pageNumber: 1
        });
      }

      return newState.merge({
        pageNumber: action.pageNumber,
        currentConversationIndex: newState.get("currentConversationIndex")
      });
    }

    case "GET_LOGS_FAILURE":
      return state.merge({
        logsLoading: false,
        hasError: true
      });
    case "CREATE_EXPRESSION_REQUEST":
      return state.set("isTraining", true);
    case "CREATE_EXPRESSION_SUCCESS":
    case "CREATE_EXPRESSION_FAILURE":
      return state.merge({
        selectedLog: null,
        isTransitioning: false,
        isTraining: false
      });
    default:
      return state;
  }
};
